import React, { useEffect } from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { Outlet, useNavigate } from "react-router-dom";
import socket, { connectSocket } from "../socket";
import { NotificationType } from "../type";

export default function Index() {
  const navigate = useNavigate();

  useEffect(() => {
    if (Notification.permission !== "granted") Notification.requestPermission();
    if (Notification.permission === "denied") {
      alert("Please Allow Notification")
    }
    connectSocket();
    socket.on("UnAuthorized", ({ status }: { status: boolean }) => {
      if (status) {
        localStorage.removeItem("user_token");
        window.location.replace("/login");
      }
    });
    socket.on(
      "Notification",
      ({ title, body, campaignId }: NotificationType) => {
        const options = {
          body: body,
          icon: "/favicon.ico",
        };

        const notification = new Notification(title!, options);
        notification.onclick = (event) => {
          event.preventDefault();
          window.focus();
          navigate("/chat-box", { state: { id: campaignId } });
        };
        // if (
        //   document.visibilityState === "hidden" ||
        //   window.location.pathname !== "/chat-box"
        // ) {

        // }
      }
    );
    return () => {
      socket.disconnect();
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div className="" style={{ maxHeight: "100vh" }}>
      <Navbar />
      <Sidebar />
      <Outlet />
    </div>
  );
}
